import { Box, Typography, Button } from "@mui/material";
import React, { useEffect, useState } from "react"
import style from "./style";
import { ReactComponent as Download } from "../../../../../assets/AccountingModule/bill_download.svg";
import { ReactComponent as Send } from "../../../../../assets/AccountingModule/bill_send.svg";
import { useNavigate } from "react-router-dom";

const PurchaserOrderViewPage = ({ handleDownload, handleShowPdf, handleSendPurchaseOrder, handleMarkReceive, purchaseOrderData }) => {
  const [billHtml, setBillHtml] = useState("")
  const navigate = useNavigate()

  useEffect(() => {
    let isMounted = true;
    const fetchBill = async () => {
      try {
        const result = await handleShowPdf();
        if (isMounted) {
          setBillHtml(result.__html);
        }
      } catch (error) {
        console.error("Error fetching bill:", error);
      }
    };
    fetchBill();
    return () => {
      isMounted = false;
    };
  }, [handleShowPdf]);

  const handleSendInvoice = () => {
    handleSendPurchaseOrder();
  };

  const hadleNavigateInvoice = () => {
    navigate('/dashboard/ConvertToBill', { state: purchaseOrderData });
  }

  return (
    <>
      <Box sx={style.mainGrid}>
        <Typography variant="h5" sx={style.leaveHeading}>
          {"Purchase Order"}
        </Typography>
        <Box sx={style.textGrid}>
          <Button
            variant="contained"
            color="success"
            sx={style.downloadBtns}
            onClick={handleDownload}
          >
            <Download />
            {"Download"}
          </Button>

          { (purchaseOrderData.status !== "Closed" || purchaseOrderData.billStatus !== "Billed") && (
            <Button
            variant="contained"
            color="success"
            sx={{...style.checkinBtnsReceive, borderLeft: "1px solid #fff"}}
            onClick={hadleNavigateInvoice}
          >
            Convert to Bill
          </Button>)}
          <Button
            variant="contained"
            color="success"
            sx={{...style.checkinBtnsReceive, borderLeft: "1px solid #fff"}}
            onClick={handleMarkReceive}
          >
            Marked Received
          </Button>
          <Button
            variant="contained"
            color="success"
            sx={{...style.checkinBtns, borderLeft: "1px solid #fff"}}
            onClick={handleSendInvoice}
          >
            <Send />
            Send Invoice
          </Button>
        </Box>
      </Box>
      <Box sx={style.whiteSection}>
        <Box dangerouslySetInnerHTML={{ __html: billHtml }} />
      </Box>
    </>
  );
}

export default PurchaserOrderViewPage;